import { ParceirosAppShell } from './ParceirosAppShell'
import { ParceirosStatusBadge } from './ParceirosStatusBadge'
import { useParceirosLeads } from './useParceirosLeads'

export default function ParceirosFinanceiro() {
  const { rows, error, loading } = useParceirosLeads()
  const commissions = rows.filter((row) => row.commission)

  return (
    <ParceirosAppShell title='Financeiro'>
      <div className='grid gap-6'>
        <div>
          <h2 className='text-2xl font-black text-text-primary'>Comissões</h2>
          <p className='mt-1 text-sm text-text-muted'>
            Só o que é seu: status e valor. Sem fatura interna, margem ou lista de outros parceiros.
          </p>
        </div>

        {error && <p className='text-sm text-red-300'>{error}</p>}

        <section className='overflow-hidden rounded-3xl border border-[var(--glass-border)] bg-[var(--bg-card)]'>
          <table className='w-full text-left text-sm text-text-primary'>
            <thead className='text-xs font-medium uppercase tracking-wider text-text-muted'>
              <tr>
                <th className='px-5 py-3'>Indicação</th>
                <th className='px-5 py-3'>Andamento</th>
                <th className='px-5 py-3'>Comissão</th>
                <th className='px-5 py-3'>Valor</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={4} className='px-5 py-8 text-text-muted'>
                    Carregando comissões…
                  </td>
                </tr>
              )}
              {!loading && commissions.length === 0 && (
                <tr>
                  <td colSpan={4} className='px-5 py-8 text-text-muted'>
                    Nenhuma comissão ainda. Ela aparece depois que o cliente fecha.
                  </td>
                </tr>
              )}
              {commissions.map((row) => (
                <tr key={row.id} className='border-t border-[var(--glass-border)]'>
                  <td className='px-5 py-3 font-medium'>{row.empresa}</td>
                  <td className='px-5 py-3'>
                    <ParceirosStatusBadge status={row.publicStatus} />
                  </td>
                  <td className='px-5 py-3 text-text-muted'>{row.commission?.status ?? '—'}</td>
                  <td className='px-5 py-3 text-text-primary'>{row.commission?.valor ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </ParceirosAppShell>
  )
}
